var map = {
	"./fino.png": 74,
	"./fino2.png": 4722,
	"./fino3.png": 6267,
	"./normal2.png": 3383,
	"./normal3.png": 4014,
	"./normal4.png": 6481,
	"./sério.png": 6176,
	"./sério2.png": 4608,
	"./sério3.png": 1513,
	"./zoião.png": 7242,
	"./zoião2.png": 4482,
	"./zoião3.png": 5659,
	"./zoião4.png": 5444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8229;